module.exports = __webpack_public_path__ + "img/9788995516430.bd3f91b4.jpg";